module.exports = __webpack_public_path__ + "a81fff6037c70d54405d14dfc9c6ba9f.jpg";